import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../../data/volumes';
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-64" data-mp="1cl64hf6kxujp">
      <div className="mx-auto w-full max-w-3xl" data-id="element-65" data-mp="1clfwt9f3kdsk">
        <SectionHeading eyebrow="🎁 Exclusive Bonuses" title={<>
              And Today, You’ll Also Get <span className="italic" data-id="element-67" data-mp="259bnnxhzjbhf">5 Exclusive Bonuses</span> — Free
            </>} intro={<p data-id="element-68" data-mp="20bju6z1ozhb4">
              Designed to help you apply the diagnostic system faster, organize your clinical
              information and communicate your decisions with greater clarity.
            </p>} data-id="element-66" data-mp="18k4abcris8ol" />

        <ul className="mt-10 space-y-6" data-id="element-69" data-mp="ku08naxw6j08">
          {bonuses.map(bonus => <li key={bonus.label} className="overflow-hidden rounded-3xl border border-slate-200 bg-bone shadow-card" data-id="element-70" data-mp="krxb85uetnlh">
              <img src={bonus.image} alt={bonus.title} className="block w-full bg-white" loading="lazy" data-id="element-71" data-mp="1euq2ih73dg38" />
              <div className="p-5 sm:p-7" data-id="element-72" data-mp="15truzoxg2qfw">
                <span className="inline-flex rounded-full bg-gold-500 px-3 py-1 text-[10px] font-extrabold tracking-[0.16em] text-navy-950" data-id="element-73" data-mp="15sp7zs38t859">
                  {bonus.label}
                </span>
                <h3 className="mt-3.5 font-display text-xl font-bold leading-snug text-navy-950 sm:text-2xl" data-id="element-74" data-mp="w1uhgbiyrme0">
                  {bonus.title}
                </h3>
                <div className="mt-3 space-y-2.5" data-id="element-75" data-mp="n3a7byrgyl1e">
                  {bonus.paragraphs.map(p => <p key={p} className="text-[14px] leading-relaxed text-slate-600" data-id="element-76" data-mp="r543btqpz0v8">
                      {p}
                    </p>)}
                </div>
                <div className="mt-4 flex flex-wrap items-center gap-2.5" data-id="element-77" data-mp="i3xjpbsrx9xr">
                  <span className="text-[13px] font-semibold text-slate-400 line-through" data-id="element-78" data-mp="i58mp9eeadnt">
                    Value: {bonus.value}
                  </span>
                  <span className="rounded-full bg-emerald-50 px-3 py-1 text-[12px] font-extrabold uppercase tracking-wide text-emerald-700" data-id="element-79" data-mp="2f11vzxjj1mz0">
                    Today: Free
                  </span>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-80" data-mp="32rphxmqa2d4k">
          <CTAButton label="I want the system + 5 bonuses" subline="Bonuses are included during the launch only" data-id="element-81" data-mp="32pblpajv2uvf" />
        </div>
      </div>
    </section>;
}